import React from "react";

export default function About() {
  return (
    <section id="about" className="about">
      <div className="container aos-init aos-animate" data-aos="fade-up">

        <div className="section-title">
          <h2>About</h2>
          <p>About Us</p>
        </div>

        <div className="row">
          <div className="col-lg-6 order-1 order-lg-2 aos-init aos-animate" data-aos="fade-left" data-aos-delay="100">
            <img src="assets/img/about.jpg" className="img-fluid" alt="" />
          </div>
          <div className="col-lg-6 pt-4 pt-lg-0 order-2 order-lg-1 content">
            <h3>ARA Learning Academy sole purpose is to “educate” every child in
unique fashion.</h3>
            <p className="font-italic">
            We at ARA , apart from teaching, will guide every
individuals to become productive. Our courses are at very affordable
rates. I request everyone to trust us once This academy was founded by
Engineers & Management students . They saw our youth are very
talented but didn’t get right platform to work upon. No one talks about
different field available, new opportunities available etc. Everyone can
earn money for nation when they are shaped in proper direction by
engaging student in every possible fields. This makes student to make
decisions in specific fields after analysing every field. We know every
institutions make different promises, we here just ask you to come to our
platform & decide. We are here to create differences. How we are
doing?, How we will do?, Any plan?
            </p>
            {/* <a href="" className="learn-more-btn">Learn More</a> */}
          </div>
        </div>

      </div>
    </section>
  );
}